export enum AddOnTypes {
  collaboration = 'collaborationActivated',
  engagementLog = 'engagementLogActivated',
  trackerAI = 'trackerAIActivated',
  contentLog = 'contentLogActivated',
}

export const TenantAddonControlFields = [
  { field: AddOnTypes.collaboration, description: 'Collaboration Addon Control' },
  { field: AddOnTypes.engagementLog, description: 'Engagement Log Addon Control' },
  { field: AddOnTypes.trackerAI, description: 'Chippy Addon Control' },
  { field: AddOnTypes.contentLog, description: 'Content Log Addon Control' },
];
